import React, { useState } from 'react'
import { FiArrowLeftCircle, FiEdit, FiEye, FiPackage, FiRefreshCcw, FiSearch, FiTrash2 } from 'react-icons/fi'
import Swal from 'sweetalert2';
import { ModalSummary } from '../../components/ModalSummary';
import { CardSummary } from '../../components/CardSummary';
import { Table } from '../../components/tables/Table';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { activateProduct, deactivateProduct, loadProducts } from '../../app/store/products/thunk';
import { product_status, status_colors } from '../../app/Constants';
import { Loading } from '../../components/Loading';
import { useForm } from 'react-hook-form';

export const ListProducts = ({ parentData, navigateTo }) => {

    const { isLoading, catalogProduct, msg, status } = useSelector(state => state.products);
    const dispatch = useDispatch();
    const { register, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({
        mode: 'all', defaultValues: {
            estado: 0
        }
    });



    useEffect(() => {

        // console.log(parentData);
        // console.log(navigateTo);

        let statusProd = 0; // default (todos)

        if (parentData?.ACTIVE) {
            statusProd = parentData.ACTIVE;

            setValue('estado', statusProd);
        }

        dispatch(loadProducts(statusProd))
    }, [parentData, dispatch])

    // Control para mostrar los detalles de cada indicador
    const [showModal, setShowModal] = useState(false);
    const [searchType, setSearchType] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    //   Abrir Modal
    const handleOpenModal = (type) => {
        setSearchType(type);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSearchType(null);
    };

    const searchProducts = (data) => {

        dispatch(loadProducts(data.estado))
    }

    const handledDelete = (id) => {
        Swal.fire({
            title: 'Atención',
            text: "Está por desactivar un Producto, ¿Desea de continuar con esta acción?",
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deactivateProduct(id));
            }
        })
    }

    const handledActive = (id) => {
        Swal.fire({
            title: 'Atención',
            text: "Está por activar un Producto, ¿Desea de continuar con esta acción?",
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(activateProduct(id));
            }
        })
    }

    let columnsProducts = [
        {
            header: 'SKU',
            dataIndex: 'SKU',
            classHeader: 'text-start',
            classRow: 'text-start',
            renderer: (value, row) => (
                <>
                    <button type="button" className="btn btn-link" onClick={() => { setSelectedItem(row.SKU); navigateTo('edit', { sku: row.SKU }); }} >{value}</button>
                </>
            ),
        },
        {
            header: 'CATEGORIA',
            dataIndex: 'NAMECATEGORY',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'MARCA',
            dataIndex: 'NAMEBRAND',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'PRODUCTO',
            dataIndex: 'NAME_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'DESCRIPCION',
            dataIndex: 'DESCRIPTION_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'EXISTENCIAS',
            dataIndex: 'CURRENTSTOCK',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'COSTO',
            dataIndex: 'PURCHASE_PRICE',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },
        {
            header: 'PRECIO',
            dataIndex: 'SALE_PRICE',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },
        {
            header: 'ESTADO',
            dataIndex: 'ACTIVE',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value) => {
                const code = Number(value);
                return (
                    <span className={`badge ${status_colors[code]}`}>
                        {product_status[code]}
                    </span>
                );
            }
        },
        {
            header: 'ACCIONES',
            dataIndex: 'ACTIVE',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => {
                const isDeleted = Number(row.ACTIVE) === 0;
                return (
                    <div className="btn-group border-0" role="group">
                        {/* Ver / Editar */}
                        <button type="button" className="btn btn-outline-primary border-0" onClick={() => { setSelectedItem(row.SKU); navigateTo('edit', { sku: row.SKU }); }} title="Ver / Editar">
                            <FiEye size={18} /> <FiEdit size={18} className="ms-1" />
                        </button>
                        {/* Activar o Eliminar según estado */}
                        {isDeleted ? (
                            <button type="button" className="btn btn-outline-success border-0" onClick={() => handledActive(row.SKU)} title="Activar producto" >
                                <FiRefreshCcw size={20} />
                            </button>
                        ) : (
                            <button type="button" className="btn btn-outline-danger border-0" onClick={() => handledDelete(row.SKU)} title="Desactivar producto">
                                <FiTrash2 size={20} />
                            </button>
                        )}

                    </div>
                );
            }
        }
    ];

    const products = [...catalogProduct];

    return (
        <>
            {showModal && (<ModalSummary type={searchType} onClose={handleCloseModal} />)}
            {
                (isLoading) ? <Loading /> :
                    <div className="row">
                        <div className='col-12'>
                            <h1 className="h3 mb-3 fw-bold">
                                Productos
                            </h1>
                        </div>

                        {/* Indicadores principales */}
                        {/* <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mt-3'>
                            <CardSummary title={'Mas vendido'} value={0} icon={'medal'} searchType={10} onOpenModal={handleOpenModal} />
                        </div>
                        <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mt-3'>
                            <CardSummary title={'Menos vendido'} value={0} icon={'exclamationRed'} searchType={11} onOpenModal={handleOpenModal} />
                        </div>
                        <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mt-3'>
                            <CardSummary title={'Debe resurtirse'} value={0} icon={'cancel'} searchType={5} onOpenModal={handleOpenModal} />
                        </div>
                        <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mt-3'>
                            <CardSummary title={'Con orden de compra'} value={0} icon={'orderList'} searchType={12} onOpenModal={handleOpenModal} />
                        </div> */}

                        {/* Card con la tabla */}
                        <div className='col-12 '>
                            <div className="card">
                                <div className="card-header fw-bold border-bottom d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
                                    <form className='row' onSubmit={handleSubmit(searchProducts)} >
                                        <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9 '>
                                            <label className="form-label">Estado:</label>
                                            <select className="form-select w-100" {...register("estado")}>
                                                <option value={0}>TODOS</option>
                                                <option value={1}>ÓPTIMO</option>
                                                <option value={2}>BAJO</option>
                                                <option value={3}>MÍNIMO</option>
                                                <option value={4}>RESURTIR</option>
                                                <option value={5}>AGOTADO</option>
                                            </select>
                                        </div>

                                        <div className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 col-xxl-1 mt-1">
                                            <div className=" mt-4">
                                                <button type="submit" className="btn btn-outline-secondary">
                                                    <FiSearch size="20" />
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                    <div>
                                        <button type="button" className="btn btn-outline-primary" onClick={() => navigateTo('new')}> Agregar nuevo producto</button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <Table
                                        columns={columnsProducts}
                                        data={products}
                                        function_={(row) => { setSelectedItem(row.SKU); navigateTo('edit', { sku: row.SKU }); }}
                                        placeholderSearch="Buscar por: SKU, Codigo de Barra, Nombre, Descripcion, Tipo"
                                        showPagination={true}
                                        showControls={true}
                                        showTotals={false}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>

            }
        </>

    )
}
